<template>
  <div class="detailPage">
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">发货单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.orderNumber">{{
            orderDetailData.orderNumber
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && (orderDetailData.status.code=='CANCEL_SHIPMENT' || orderDetailData.status.code=='WAIT_SHIPMENT')"
            class="el-icon-edit allowSkip" 
            @click="editOrderNumber(orderDetailData.orderNumber)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customer">{{
            orderDetailData.customer.name
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.customer && orderDetailData.customer.id=='104743546417065984'"
            class="el-icon-upload allowSkip" title="上传信息"
            @click="upsert()"
          ></i>
            <i v-if="orderDetailData.customer && orderDetailData.customer.id=='104743546417065984'"
               class="el-icon-download allowSkip" title="下载信息"
               @click="dowload_shipmentOrder()"
            ></i>
        </div>
      </li>
      <li>
        <div class="left">发货数量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.quantity">
            {{ orderDetailData.quantity }}PCS
            <i v-if="orderDetailData.status && orderDetailData.status.code=='WAIT_SHIPMENT'"
              class="el-icon-edit allowSkip"
              @click="editQuantityBtn(orderDetailData.quantity)"
            ></i>
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">栈板规格：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.quantityInPallet">
            {{ orderDetailData.quantityInPallet }}/栈板
          </span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='WAIT_SHIPMENT'"
            class="el-icon-edit allowSkip"
            @click="editInPalletBtn(orderDetailData)"
          ></i>
        </div>
      </li>
      <li v-if="(orderDetailData.customer && orderDetailData.customer.id) && (orderDetailData.customer.id=='49556885111701504' || orderDetailData.customer.id=='33516488737554432')">
        <div class="left">起始栈板号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.startPalletIndex">
            {{ orderDetailData.startPalletIndex }}
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="(orderDetailData.customer && orderDetailData.customer.id) && (orderDetailData.customer.id=='49556885111701504' || orderDetailData.customer.id=='33516488737554432')">
        <div class="left">栈板号模版：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.palletSnTemplate">
            {{ orderDetailData.palletSnTemplate }}
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户物料编码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.partNum">{{
            orderDetailData.partNum
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && (orderDetailData.status.code=='WAIT_SHIPMENT' || orderDetailData.status.code=='CANCEL_SHIPMENT')"
            class="el-icon-edit allowSkip"
            @click="editPartNumBtn(orderDetailData.partNum)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">采购单/入库单：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.srmOrderNum">{{
            orderDetailData.srmOrderNum
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && (orderDetailData.status.code=='CANCEL_SHIPMENT' || orderDetailData.status.code=='WAIT_SHIPMENT')"
            class="el-icon-edit allowSkip"
            @click="editSrmOrderBtn(orderDetailData.srmOrderNum)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">发货批次号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.lotPo">{{
            orderDetailData.lotPo
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && (orderDetailData.status.code=='CANCEL_SHIPMENT' || orderDetailData.status.code=='WAIT_SHIPMENT')"
            class="el-icon-edit allowSkip"
            @click="editLotPoBtn(orderDetailData.lotPo)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">工单状态：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.status && orderDetailData.dpkStatus">{{
            orderDetailData.exWarehouseDateTime ? orderDetailData.status.title + "【"+orderDetailData.exWarehouseDateTime+"】" : orderDetailData.status.title
          }} {{"【CBR"+orderDetailData.dpkStatus.title+"】"}}</span>
          <span class="value" v-else-if="orderDetailData.status">{{
            orderDetailData.exWarehouseDateTime ? orderDetailData.status.title + "【"+orderDetailData.exWarehouseDateTime+"】" : orderDetailData.status.title
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <!-- <li>
        <div class="left">上传报表：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.uploadReport">是</span>
          <span v-else>否</span>
        </div>
      </li> -->
      <li v-if="orderDetailData.status &&  orderDetailData.status.code!='WAIT_SHIPMENT' && orderDetailData.uploadStatus">
        <div class="left">上传状态：</div>
        <div class="right">
          <span class="value">{{
            orderDetailData.uploadTime ? orderDetailData.uploadStatus.title + "【"+orderDetailData.uploadTime+"】" : orderDetailData.uploadStatus.title
          }}</span>
          <span class="value" v-if="orderDetailData.uploadStatus && orderDetailData.uploadStatus.code=='FAIL'">
            (<span class="allowSkip"
              @click="uploadFile(orderDetailData.id)"
              >重新上传</span>&nbsp;|&nbsp;<span class="allowSkip"
              @click="abortUpload(orderDetailData.id)"
              >终止上传</span>)
          </span>
          <span class="value" v-if="orderDetailData.reportFid > 0">
            (<span class="allowSkip"
              @click="downloadFile(orderDetailData.reportFid, orderDetailData.fileName, orderDetailData.secretKey)"
              >报表下载</span>)
          </span>
        </div>
      </li>
      <li v-if="orderDetailData.status">
        <div class="left">承运人：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.express">{{
            orderDetailData.express
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="orderDetailData.status">
        <div class="left">车牌号/运单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.expressNumber">{{
            orderDetailData.expressNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="orderDetailData.status">
        <div class="left">目的地：</div>
        <div class="right">
          <span class="value">{{
            orderDetailData.destination ? orderDetailData.destination : '-'
          }}
            <i v-if="orderDetailData.status && (orderDetailData.status.code=='CANCEL_SHIPMENT' || orderDetailData.status.code=='WAIT_SHIPMENT')"
              class="el-icon-edit allowSkip"
              @click="editDestination(orderDetailData.destination)"
            ></i></span>
        </div>
      </li>
      <li v-else>
        <div class="left">建单时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.createDate">
            {{ orderDetailData.createDate }}
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">所有者：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.createUser">{{
            orderDetailData.createUser.name + " (" + orderDetailData.createUser.employeeNum+")"
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">备注：</div>
        <div class="right">
          <span class="value">
            {{orderDetailData.notes ? orderDetailData.notes : '-'}}
            <i v-if="orderDetailData.status && (orderDetailData.status.code=='CANCEL_SHIPMENT' || orderDetailData.status.code=='WAIT_SHIPMENT')"
              class="el-icon-edit allowSkip"
              @click="editNotes(orderDetailData.notes)"
            ></i></span>
        </div>
      </li>
      <li class="blockLi">
        <div class="left">包装工单：</div>
        <div class="right">
          <el-table
            stripe
            :data="orderDetailData.cartonOrders"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column
              prop="orderNumber"
              label="包装工单"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.orderNumber">{{
                  scope.row.orderNumber
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" label="工单数量" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.quantity>0">{{ scope.row.quantity }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quantityOfCarton"
              label="外箱规格"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.outer">{{ scope.row.outer.pack }}/箱</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="发货数量" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.shipmentQuantity }}</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="operation"
              label="操作"
              align="center"
              width="70px"
            >
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.orderNumber && scope.row.shipmentQuantity==0" effect="dark" content="删除" placement="top" :open-delay="300">
                  <i @click="deleteOrder($event, scope.row)"
                    class="el-icon-delete"></i>
                </el-tooltip>
                <span v-if="scope.row.orderNumber && scope.row.shipmentQuantity>0">
                  -
                </span>
                <el-tooltip v-if="!scope.row.orderNumber" effect="dark" content="添加" placement="top" :open-delay="300">
                  <i @click="
                    selectVisible($event, 'cartonOrder', '包装工单')"
                    class="el-icon-plus"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
      <li class="blockLi">
        <div class="left">组装工单：</div>
        <div class="right">
          <el-table
            stripe
            :data="orderDetailData.productionOrders"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column
              prop="orderNumber"
              label="组装工单"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.orderNumber">{{
                  scope.row.orderNumber
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" label="工单数量" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.quantity }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="product" label="型号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.product">{{
                  scope.row.product.code
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="发货数量" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.shipmentQuantity }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <template v-if="dialogTitle == '修改发货单号'">
            <el-form-item label="发货单号：" size="small" prop="orderNumber">
              <el-input
                v-model="dialogForm.orderNumber"
                :precision="0"
                placeholder="请输入新发货单号"
                :controls="false"
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '修改发货数量'">
            <el-form-item label="发货数量：" size="small" prop="quantity">
              <el-input-number
                v-model="dialogForm.quantity"
                :min="1"
                :precision="0"
                placeholder="发货工单数量"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '修改备注'">
            <el-form-item label="备注：" size="small" prop="notes">
              <el-input
                v-model="dialogForm.notes"
                placeholder="备注"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改栈板规格'">
            <el-form-item
              label="栈板规格："
              size="small"
              prop="quantityInPallet"
            >
              <el-input-number
                v-model="dialogForm.quantityInPallet"
                :min="1"
                :precision="0"
                placeholder="每栈板的裸机数量"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始栈板号："
              size="small"
              prop="startPalletIndex"
            >
              <el-input-number
                v-model="dialogForm.startPalletIndex"
                :min="1"
                :precision="0"
                placeholder="此发货单的起始栈板号"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="栈板号模版："
              size="small"
              prop="palletSnTemplate"
            >
              <el-input
                v-model="dialogForm.palletSnTemplate"
                placeholder="客户定制栈板SN规则"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '修改批号'">
            <el-form-item label="采购单/入库单" size="small" prop="srmOrderNum">
              <el-input
                v-model="dialogForm.srmOrderNum"
                placeholder="输入客户的采购单号或入库单号"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '修改发货批次号'">
            <el-form-item label="发货批次号" size="small" prop="lotPo">
              <el-input
                v-model="dialogForm.lotPo"
                placeholder="输入客户的发货批次号"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '修改物料编码'">
            <el-form-item label="客户物料编码" size="small" prop="partNum">
              <el-input
                v-model="dialogForm.partNum"
                placeholder="输入客户物料编码"
                clearable
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiShipmentOrderDetail,
  apiShipUpdateQuantity,apiShipUpdateNotes,apiShipUpdateDestination,
  apiShipUpdatePalletQuantity,
  apiShipUpdateSrmOrder,apiShipUpdateLotPo,
  apiShipUpdateOrderNumber,
  apiShipUpdatePartNum,
  apiShipmentOrderUpload,
  apiShipmentOrderAddCartonOrder,
  apiShipmentOrderRemoveCartonOrder,
  apiShipmentOrderAbortUpload,
  apiDeviceForShipmentOrderUpsert, apiDowloadShipmentOrder
} from "@/api/shipmentOrder.js";
import { apiDownloadFile } from "@/api/filesUpload.js";
import myDialog from "@/components/myDialog.vue";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  components: {
    myDialog,
    orderTableSelect,
  },
  data() {
    return {
      orderDetailData: {},
      dialogTitle: "",
      dialogForm: {cartonOrderIds: []},
      dialogRules: {
        quantity: [
          { required: true, message: "发货数量不能为空！", trigger: "blur" },
        ],
        quantityInPallet: [
          { required: true, message: "栈板规格不能为空！", trigger: "blur" },
        ],
      },
      pullDownData: {      
        cartonOrderList: []
      },
      labelWidth: "100px",
      // labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 订单表格提交
    async orderTableSubmit({ orderName, selectRow}) {
      this.$set(
        this.dialogForm,
        `${orderName + "Ids"}`,
        selectRow.map((item) => item.id)
      );
      this.$set(this.pullDownData, `${orderName + "List"}`, selectRow);
      const res = await apiShipmentOrderAddCartonOrder({
        id: this.tabPaneValue,
        cartonOrderId: this.dialogForm.cartonOrderIds
      });
      if (res.code==0) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
        this.getShipmentOrderDetail();
      }
    },
    // 新建工单-包装工单
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.parameter = {
          customerId: this.orderDetailData.customer.id,
          selectedRow: this.orderDetailData.cartonOrders.filter((item) =>
            this.dialogForm.cartonOrderIds.includes(item.id)
          ),
        };
        this.$refs.orderTableSelect.openDialog();
      }
    },
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "包装工单").then(
        async () => {
          const res = await apiShipmentOrderRemoveCartonOrder({
            id: this.tabPaneValue,
            cartonOrderId: [row.id],
          });
          if (res.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getShipmentOrderDetail();
          }
        }
      );
    },
    async abortUpload(id) {
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：终止上传后无法在自动重新上传！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, this.orderDetailData.orderNumber),
          h("span", null, `】以确认终止上传！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.orderDetailData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(
        async () => {
          const res = await apiShipmentOrderAbortUpload({
            id: id,
          });

          this.$message({
            message: res.msg,
            type: res.code==0 ? "success" : "error"
          });
          this.getShipmentOrderDetail();
      });
    },
    async uploadFile(id) {
      const res = await apiShipmentOrderUpload({
        id: id,
      });
      if (res.code==0) {
        this.getShipmentOrderDetail();
      }
    },
    downloadFile(fid, fileName, secret) {
      let a = document.createElement("a");
      a.download = fileName;
      a.href = apiDownloadFile(fid, secret);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 订单详情数据
    async getShipmentOrderDetail(callback) {
      const res = await apiShipmentOrderDetail({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        this.orderDetailData = res.data;
        this.$parent.tabPaneData.status=this.orderDetailData.status;
        this.$parent.tabPaneData.quantity=this.orderDetailData.quantity;
        this.$parent.tabPaneData.dpkStatus=this.orderDetailData.dpkStatus;
        if (callback) callback();
        this.dialogForm.cartonOrderIds = [];
        this.orderDetailData.cartonOrders.forEach(item => {
          if (item.id > 0) {
            this.dialogForm.cartonOrderIds.push(item.id);
          }
        });
      }
    },
    editQuantityBtn(quantity) {
      this.dialogTitle = "修改发货数量";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        quantity,
      };
    },
    editNotes(notes) {
      this.dialogTitle = "修改备注";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        notes,
      };
    },
    editDestination(destination) {
      this.dialogTitle = "修改目的地";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        destination,
      };
    },
    editInPalletBtn(data) {
      this.dialogTitle = "修改栈板规格";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        quantityInPallet: data.quantityInPallet,
        startPalletIndex: data.startPalletIndex,
        palletSnTemplate: data.palletSnTemplate
      };
    },
    editOrderNumber(orderNumber) {
      this.dialogTitle = "修改发货单号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        orderNumber: orderNumber,
      };
    },
    editSrmOrderBtn(srmOrderNum) {
      this.dialogTitle = "修改批号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        srmOrderNum,
      };
    },
    editLotPoBtn(lotPo) {
      this.dialogTitle = "修改发货批次号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        lotPo,
      };
    },
    editPartNumBtn(partNum) {
      this.dialogTitle = "修改物料编码";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        partNum,
      };
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "修改发货数量") {
            res = await apiShipUpdateQuantity({
              // id: this.tabPaneValue,
              ...this.dialogForm,
            });
          } else if (title == "修改备注") {
            res = await apiShipUpdateNotes({
              // id: this.tabPaneValue,
              ...this.dialogForm,
            });
          } else if (title == "修改目的地") {
            res = await apiShipUpdateDestination({
              // id: this.tabPaneValue,
              ...this.dialogForm,
            });
          } else if (title == "修改栈板规格") {
            res = await apiShipUpdatePalletQuantity({
              id: this.tabPaneValue,
              quantity: this.dialogForm.quantityInPallet,
              startPalletIndex: this.dialogForm.startPalletIndex,
              palletSnTemplate: this.dialogForm.palletSnTemplate
            });
          } else if (title == "修改发货单号") {
            res = await apiShipUpdateOrderNumber({
              ...this.dialogForm,
            });
          } else if (title == "修改批号") {
            res = await apiShipUpdateSrmOrder({
              ...this.dialogForm,
            });
          } else if (title == "修改发货批次号") {
            res = await apiShipUpdateLotPo({
              ...this.dialogForm,
            });
          } else if (title == "修改物料编码") {
            res = await apiShipUpdatePartNum({
              ...this.dialogForm,
            });
          }
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.getShipmentOrderDetail();
            this.$message({
              message: `修改成功`,
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    upsert() {
      const h = this.$createElement;
              this.$msgbox({
                title: `将当前工单已生产的产品信息上传给高德`,
                message: h("div", null, [
                  h("span", null, `请输入工单号:【`),
                  h("i", { style: "color: var(--themeColor)" }, this.orderDetailData.orderNumber),
                  h("span", null, `】以确认上传！`)
                ]),
                showCancelButton: true,
                confirmButtonText: `上传`,
                cancelButtonText: "取消",
                closeOnClickModal: false,
                showInput: true,
                beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {
                    if (instance.inputValue === this.orderDetailData.orderNumber) {
                      done()
                    } else {
                      this.$message({
                        type: "warning",
                        message: `输入错误，请重新输入或取消！`
                      })
                    }
                  } else {
                    done()
                  }
                }
              }).then(async () => {
                const res = await apiDeviceForShipmentOrderUpsert({
                  id: this.tabPaneValue,
                });
                if (res.code==0) {
                  this.$message({
                    message: res.msg + "，"+res.data,
                    type: "success",
                  });
                }
              })
    },
    dowload_shipmentOrder() {
          const h = this.$createElement;
          this.$msgbox({
              title: `即将下载上传给高德的数据`,
              message: h("div", null, [
                  h("span", null, `请输入工单号:【`),
                  h("i", { style: "color: var(--themeColor)" }, this.orderDetailData.orderNumber),
                  h("span", null, `】以确认下载！`)
              ]),
              showCancelButton: true,
              confirmButtonText: `下载`,
              cancelButtonText: "取消",
              closeOnClickModal: false,
              showInput: true,
              beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {
                      if (instance.inputValue === this.orderDetailData.orderNumber) {
                          done()
                      } else {
                          this.$message({
                              type: "warning",
                              message: `输入错误，请重新输入或取消！`
                          })
                      }
                  } else {
                      done()
                  }
              }
          }).then(async () => {
              const res = await apiDowloadShipmentOrder({
                  id: this.tabPaneValue,
              });
              if (res.code==0) {
                  this.$message({
                      message: res.msg + "，"+res.data,
                      type: "success",
                  });
              }
          })
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
  },
};
</script>

<style lang="less" scoped>
</style>